import request from '@/utils/request'

/**
 * 获取收益和电量统计数据
 * @param {Object} params - 查询参数
 * @param {string} params.startTime - 开始时间
 * @param {string} params.endTime - 结束时间
 * @param {string} params.area - 区域
 * @returns {Promise} 返回收益和电量数据
 */
export function getMonthIncomeAndPower(params) {
  return request({
    url: '/dashboard/v3/workbench/monthIncomeAndPower',
    method: 'get',
    params
  })
}

/**
 * 获取我的电站列表
 * @param {Object} params - 查询参数
 * @param {string} params.area - 区域
 * @param {number} params.startCapacity - 开始容量区间
 * @param {number} params.endCapacity - 结束容量区间
 * @returns {Promise} 返回电站列表数据
 */
export function getMyStationList(params) {
  return request({
    url: '/dashboard/v3/workbench/myStationList',
    method: 'get',
    params
  })
}

/**
 * 获取告警列表
 * @param {Object} data - 请求体参数
 * @param {string} data.area - 区域
 * @param {string} data.name - 电站名称
 * @param {string} data.description - 告警描述
 * @param {Array<string>} data.codeList - 告警码列表
 * @param {number} params.pageNum - 页码 (query param)
 * @param {number} params.pageSize - 每页数量 (query param)
 * @returns {Promise} 返回告警列表数据
 */
export function getAlarmList(data) {
  return request({
    url: '/dashboard/v3/workbench/alarmList',
    method: 'post',
    data
  })
}

/**
 * 获取告警码列表（用于筛选）
 * @returns {Promise} 返回告警码列表
 */
export function getAlarmCodeList(params) {
  return request({
    url: '/dashboard/v3/alarm/alarmCodeList',
    method: 'get',
    params
  })
}

/**
 * 获取电站统计数据
 * @returns {Promise} 返回电站数量、容量等统计信息
 */
export function getStationData() {
  return request({
    url: '/device/v2/station/data',
    method: 'get'
  })
}
